module.exports = __webpack_public_path__ + "static/media/eg.31261d27.svg";